export const ERROR_CATCH = 'ERROR_CATCH';
export const INSUFFICIENT_FUNDS_ERROR_CATCH = 'INSUFFICIENT_FUNDS_ERROR_CATCH';
export const CLEAN_BILLING_ERROR = 'CLEAN_BILLING_ERROR';
export const CLEAN_INSUFFICIENT_FUNDS_ERROR = 'CLEAN_INSUFFICIENT_FUNDS_ERROR';
